import { useEconomicCalendarSectionContent } from './useEconomicCalendarSectionContent';
import { parseEconomicCalendarSimpleWorkflowContent } from '../utils/economicCalendarContent';

export const useEconomicCalendarSimpleWorkflowContent = () =>
  useEconomicCalendarSectionContent(parseEconomicCalendarSimpleWorkflowContent);
